<template>
  <div class="layout-topbar" v-if="this.$store.state.auth.loggedIn">
    <button
      class="p-link layout-menu-button"
      @click="onMenuToggle"
      v-tooltip="'Mostrar/Ocultar menu'"
    >
      <span class="pi pi-bars"></span>
    </button>
    <div class="layout-topbar-icons">
      <!-- <i
        class="pi pi-envelope p-mr-4"
        style="font-size: 20px; width: 30px; cursor: pointer"
        v-badge="unreadProposalMsg"
        v-tooltip.left="'Emails Propostas Não Lidos'"
        @click="$router.push('/proposals-unread-messages').catch(() => {})"
      ></i>
      <i
        class="pi pi-inbox mr-4"
        style="font-size: 20px; width: 30px; cursor: pointer"
        v-badge="unreadMsg"
        v-tooltip.left="'Mensagens'"
        @click="$router.push('/messages').catch(() => {})"
      ></i> -->
      <StatusControlPatIndicator v-if="can('seeTechnicalManagementStatusControlPatIndicator')" />
      <ServiceOrdersTopbarIndicator v-if="can('seeServiceOrders')" />
      <button v-if="hasChatPermission" class="p-link layout-topbar-chat" @click="goToChats" v-tooltip.left="'Chats'">
        <span class="layout-topbar-icon-wrapper">
          <span class="layout-topbar-icon pi pi-comments"></span>
          <span v-if="notifications" class="chat-notification-ping" aria-hidden="true">
            <span class="chat-notification-ping-outer"></span>
            <span class="chat-notification-ping-inner"></span>
          </span>
        </span>
      </button>
      <button class="p-link" @click="logout()" v-tooltip.left="'Logout'">
        <span class="layout-topbar-icon pi pi-sign-out"></span>
      </button>
    </div>
  </div>
</template>

<script>
import ChatService from '@/services/chat.service';
import StatusControlPatIndicator from '@/components/support/StatusControlPatIndicator.vue';
import ServiceOrdersTopbarIndicator from '@/components/serviceOrders/ServiceOrdersTopbarIndicator.vue';

export default {
  name: 'AppTopbar',
  components: {
    StatusControlPatIndicator,
    ServiceOrdersTopbarIndicator,
  },
  data() {
    return {
      unreadMsg: 0,
      unreadProposalMsg: 0,
      notifications: false,
      timer: null
    };
  },
  created() {},
  computed: {
    hasChatPermission() {
      const storeUser = this.$store?.state?.auth?.user;
      const payload = storeUser?.moreInfo ?? this.readStoredUser()?.moreInfo;
      const acls = this.parseAclPayload(payload);
      return acls.includes('sendMessageInPatChat');
    }
  },
  watch: {
    hasChatPermission: {
      immediate: true,
      handler(canSend) {
        if (canSend) {
          this.startNotificationsTimer();
        } else {
          this.stopNotificationsTimer();
          this.notifications = false;
        }
      }
    }
  },

  beforeDestroy() {
    this.stopNotificationsTimer();
  },
  methods: {
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    goToChats() {
      this.$router.push("/chats").catch(() => {});
    },
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    countUnreadMessages() {
    },
    async startNotificationsTimer() {
      if (this.timer) return;
      await this.getNotifications();
      this.timer = setInterval(() => {
        this.getNotifications();
      }, 5 * 60 * 1000);
    },
    stopNotificationsTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    readStoredUser() {
      try {
        const stored = localStorage.getItem('user');
        return stored ? JSON.parse(stored) : null;
      } catch (error) {
        console.error('[Topbar] Failed to parse stored user:', error);
        return null;
      }
    },
    parseAclPayload(payload) {
      if (!payload) return [];
      if (Array.isArray(payload)) return payload;
      try {
        const decoded = typeof payload === 'string' ? window.atob(payload) : payload;
        const parsed = typeof decoded === 'string' ? JSON.parse(decoded) : decoded;
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error('[Topbar] Failed to decode ACL payload:', error);
        return [];
      }
    },
    async getNotifications() {
      try {
        const response = await ChatService.getMessagesNotifications();
        this.notifications = Number(response) > 0;
      } catch (error) {
        if (this.$toast) {
          this.$toast.add({ severity: "error", summary: "Erro ao carregar notifiações.", life: 4000 })
        }
      }
    },
  },
};
</script>
<style scope>
.p-tooltip {
  z-index: 1000 !important;
}

.layout-topbar-icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.layout-topbar-chat:focus {
  outline: none !important;
  box-shadow: none !important;
}
.chat-notification-ping {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.chat-notification-ping-outer {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 9999px;
  background: rgba(248, 113, 113, 0.75);
  animation: notification-ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
}
.chat-notification-ping-inner {
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: #ef4444;
}
@keyframes notification-ping {
  0% {
    transform: scale(0.8);
    opacity: 0.75;
  }
  75%,
  100% {
    transform: scale(1.75);
    opacity: 0;
  }
}
</style>
